/* eslint-disable no-prototype-builtins */
import api from '../../utils/api';

const url = 'memberships';
const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};
export default {
  getMembershipConfig: ({ id, ...params } = {}) =>
    api.makeEndpoint('get', `${url}/${id}?${serialize(params)}`)(),
  checkIn: api.makeEndpoint('post', `${url}/check-in`),
  register: api.makeEndpoint('post', `${url}/register`),
  registerWithImage: (payload) =>
    api.file(`${url}/register-with-image`, payload),
  addSecondaryMember: api.makeEndpoint('post', `${url}/add-secondary-member`),
  addSecondaryMemberWithImage: (payload) =>
    api.file(`${url}/add-secondary-member-with-image`, payload),
  updateMemberPhoto: (payload) => api.file(`${url}/photo`, payload),
  createSubscription: api.makeEndpoint('post', `${url}/create-subscription`),
  cancelRequest: api.makeEndpoint('post', `${url}/cancel/request`),
  cancelMembership: (payload) => api.post(`${url}/cancel/confirm`, payload),
  getMembershipById: (id, extraFields) =>
    api.makeEndpoint('get', `${url}/${id}/info?${serialize(extraFields)}`),
  validateMembershipCode: api.makeEndpoint(
    'post',
    `${url}/validate-membership-code`
  ),
  validateSignUpCoupon: api.makeEndpoint(
    'post',
    `${url}/validate-sign-up-coupon`
  ),
  updateMembershipCardOnFile: api.makeEndpoint('post', `${url}/update-ccof`),
  restartMembership: api.makeEndpoint('post', `${url}/restart`),
  restartChangePlanRequest: (payload) =>
    api.post(`${url}/restart-change-plan/request`, payload),
  restartChangePlanConfirm: (payload) =>
    api.post(`${url}/restart-change-plan/confirm`, payload),
  cardOnFileInfo: (payload) => api.post(`${url}/card-on-file/info`, payload),
  cardOnFileUpdate: (payload) =>
    api.post(`${url}/card-on-file/update`, payload),
  cardOnFileDelete: (payload) =>
    api.post(`${url}/card-on-file/delete`, payload),
  resendMembershipEmail: api.makeEndpoint('post', `${url}/resend`),
  sendRestartMembershipEmail: api.makeEndpoint('post', `${url}/restart-email`),
  getMembershipFreeItemConfig: (params) =>
    api.makeEndpoint('get', `${url}/${params}/free-item-configs`)(),
  getMembershipFreeItem: (memberId) =>
    api.makeEndpoint('get', `${url}/${memberId}/free-items`)(),
  createMembershipFreeItem: (payload) =>
    api.makeEndpoint('post', `${url}/create-free-item`)(payload),
  getMembershipByCode: (payload) =>
    api.get(`${url}/${payload.businessId}/get-by-code/?code=${payload.code}`),
  getSecret: (payload) => api.post(`${url}/secret`, payload),
  verificationRequest: (payload) => api.post(`${url}/verify/request`, payload),
  verificationConfirm: (payload) => api.post(`${url}/verify/confirm`, payload),
  getIntegrationCustomerProfile: (payload) =>
    api.post(`${url}/integration/profile`, payload),
};
